import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';

const nnsManagement = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      totalPage: 0,

      requestData: null,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    clearErrorVariable(state, variable) {
      state.errors[variable] = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },

    removeData(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter((value) => value.id != index);
    },

    pushData(state, { payload }) {
      state.totalData += 1;
      state.allData.push(payload);
    },

    editData(state, { payload, index }) {
      Object.assign(state.allData[index], payload);
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'id'} ${sort}`;

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            sort_by +
              itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/nns/nns/index`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async addNns(ctx, { date, dataForm }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        bank_code: dataForm.bank_code,
        bank_name: dataForm.bank_name,
        bank_nns: dataForm.bank_nns,
        brand_name: dataForm.brand_name,
        version: btoa(
          CryptoJS.SHA256(
            dataForm.bank_code +
              dataForm.bank_nns +
              dataForm.bank_name +
              dataForm.brand_name +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/nns/nns/create`;

      const responseData = await postApi(ctx, urlApi, data);
      let resVal = false;
      if (responseData?.code == 200) {
        const newData = responseData.data;
        ctx.commit('pushData', {
          payload: newData,
        });
        resVal = true;
      }
      return resVal;
    },

    async updateNns(ctx, { date, dataForm, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id: dataForm.id,
        bank_code: dataForm.bank_code,
        bank_name: dataForm.bank_name,
        bank_nns: dataForm.bank_nns,
        brand_name: dataForm.brand_name,
        version: btoa(
          CryptoJS.SHA256(
            dataForm.id +
              dataForm.bank_code +
              dataForm.bank_nns +
              dataForm.bank_name +
              dataForm.brand_name +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/nns/nns/edit`;

      const responseData = await postApi(ctx, urlApi, data);
      let resVal = false;
      if (responseData?.code == 200) {
        const updated = responseData.data;
        ctx.commit('editData', {
          payload: updated,
          index,
        });
        resVal = true;
      }
      return resVal;
    },
  },
};

export default nnsManagement;
